<template>
    <div>
        <app-navigation></app-navigation>
        <router-view></router-view>
    </div>
</template>

<script>
    import Navigation from './Navigation'
    export default {
        components: {
            appNavigation: Navigation
        },
        mounted () {
            this.$store.dispatch('checkUpdateUserRole')
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue